import { IRichContentEditorState } from '../../../../extViewmodels';
import {
	IRichContentDocumentEditorConfig,
	RichContentDocumentEditor,
} from '../../../../web/components/richContent/RichContentDocumentEditor';
import { styleSheet } from './styles';
import { css } from 'aphrodite';
import * as React from 'react';

interface IProps {
	contentEditorState: IRichContentEditorState;
	onContentEditorStateChanged: (contentEditorState: IRichContentEditorState) => void;
}

const config: IRichContentDocumentEditorConfig = {
	plugins: 'autolink',
	toolbar: '',
};

export const CitationEditor: React.FC<IProps> = ({ contentEditorState, onContentEditorStateChanged }) => {
	return (
		<div>
			<div className={css(styleSheet.subHeader)}>Citations</div>
			<RichContentDocumentEditor
				className={css(styleSheet.editor)}
				config={config}
				contentState={contentEditorState}
				onContentStateChanged={onContentEditorStateChanged}
				readOnlyUseFullEditor={true}
			/>
		</div>
	);
};
